import { FC } from 'react';
import * as R from 'ramda';
import { Connection, Handle, NodeProps, Position } from 'react-flow-renderer';
import Node, { contentStyle as style } from './Node';
import { Badge, Box } from '@mui/material';

const isValidInput = (connection: Connection) => {
  return R.split('_', connection.source as string)[0].substring(0, 8) === 'campanha';
};

export const FimNode: FC<NodeProps> = ({ data, selected, }) => {
  return (
    <Badge badgeContent={data.erros | 0} color="error">
      <Node
        label='Fim'
        icon='stop_cicle'
        selected={selected}
        color={'#C2BA7C'}
        content={
          <Box style={style.io}>
            {data.label}
            <Handle
              type='target'
              position={Position.Left}
              id={'i__data'}
              style={{ ...style.handle, ...style.left }}
              isValidConnection={isValidInput}
            />
          </Box>
        }
      />
    </Badge>

  );
};


